
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0m0,5A3,3,0,1,1,9,8a3,3,0,0,1,3-3m5.308,12.463c-2.222,2.047-8.384,2.052-10.608,0S7.909,12.047,12,12c4.068.044,7.53,3.416,5.308,5.463"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  